import { Chakra } from "@airhelp/react-ui-components";
import PropTypes from "prop-types";
import { CheckmarkIcon, CloseIcon, InfoIcon } from "styles/icons";
import { useTranslations } from "contexts/LocalizationContext/hooks";

const { Flex, Text, PopoverContent: ChakraPopoverContent, Popover, PopoverTrigger, Box } = Chakra;

const PopoverContent = ({ heading, content }) => (
  <ChakraPopoverContent
    zIndex="popover"
    p={{ base: 4, md: 8 }}
    maxW={{ base: 64, md: "344px" }}
    color="primary.900"
    rounded="lg"
  >
    <Text fontWeight="bold" mb={2}>
      {heading}
    </Text>
    <Text>{content}</Text>
  </ChakraPopoverContent>
);

const PopoverIcon = ({ icon, heading, content, ...props }) => (
  <Popover trigger="hover" placement="top-start">
    <PopoverTrigger>
      <Box as="span" role="button" tabIndex="0" {...props}>
        {icon}
      </Box>
    </PopoverTrigger>
    <PopoverContent heading={heading} content={content} />
  </Popover>
);

PopoverIcon.propTypes = {
  icon: PropTypes.node,
  heading: PropTypes.string,
  content: PropTypes.string,
};

PopoverIcon.defaultProps = {
  icon: <InfoIcon color="greyscale.600" boxSize={4} />,
  heading: "",
  content: "",
};

const PlanBoxItem = ({ item }) => {
  const translations = useTranslations();
  const { popover, text, translationVariables, highlighted, inactive, iconText } = item;
  const mainText = translations(text, translationVariables);
  const itemColor = highlighted ? "success.500" : inactive ? "greyscale.400" : "greyscale.600";
  const itemFontWeight = highlighted ? "semibold" : "normal";
  const iconColor = inactive ? "greyscale.400" : "success.500";

  return (
    <Flex key={text} mb={4} alignItems="flex-start" color="primary.900">
      {iconText ? (
        <Text ml={-2} mr={2} color={iconColor} fontSize="sm" fontWeight="semibold" lineHeight="short">
          {translations(iconText)}
        </Text>
      ) : inactive ? (
        <CloseIcon mr={2} boxSize={4} color={iconColor} />
      ) : (
        <CheckmarkIcon mt={1} mr={2} boxSize={4} color={iconColor} />
      )}
      <Text mx={2} color={itemColor} fontWeight={itemFontWeight} fontSize={{ base: "sm", lg: "md" }}>
        {mainText}
      </Text>
      {popover && <PopoverIcon heading={mainText} content={translations(popover, translationVariables)} />}
    </Flex>
  );
};

export default PlanBoxItem;

PlanBoxItem.propTypes = {
  item: PropTypes.shape({
    text: PropTypes.string.isRequired,
    popover: PropTypes.string,
    translationVariables: PropTypes.shape({}),
    translationString: PropTypes.string,
    highlighted: PropTypes.bool,
    inactive: PropTypes.bool,
    isActive: PropTypes.bool,
    iconText: PropTypes.string,
  }).isRequired,
};
